// extracted by mini-css-extract-plugin
export var leftAlign = "_29-2";
export var popper = "_29-0";
export var subtitle = "_29-1";